<template>
  <div
      v-loading="loadingHead || loadingSalesOrder || loadingBusinessApplication || loadingOperationApplication||loadingProductionApplication||loadingDeliveryNoteApplication"
      style="overflow-y: auto">
    <approval-head-form
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :combined-loading="combinedLoading"
        @sucess-save="submit"
        @loading-status="loadingStatusHead"/>
    <sales-order-preview
        v-if="billType === '1'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingStatusSalesOrder"/>
    <business-application-preview
        v-if="billType === '3'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingStatusBusinessApplication"/>
    <delivery-note-application-preview
        v-if="billType === '6'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingStatusDeliveryNoteApplication"/>
    <business-application-price-apply-preview
        v-if="billType === '20'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingStatusBusinessApplicationPriceApply"/>
    <operation-application-preview
        v-if="billType === '40'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingStatusOperationApplication"/>
    <production-application-preview
        v-if="billType === '13'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingStatusProductionApplication"/>
    <replacement-bill-application-preview
        v-if="billType === '14'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingStatusReplacementBillApplication"/>
    <Purchase-ng-application-preview
        v-if="billType === '16'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingStatusPurchaseNgApplication"/>
    <Product-ng-application-preview
        v-if="billType === '17'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingStatusProductNgApplication"/>
    <reconcile-order-preview
        v-if="billType === '27'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingReconcileOrder"/>
    <appointment-approve-preview
        v-if="billType === '15'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingStatusAppointmentApprove"/>
  </div>
</template>
<script>
  import ApprovalHeadForm from "./ApprovalHeadForm.vue";
  import ReconcileOrderPreview from "@/views/workFlow/ReconcileOrderPreview";
  import AppointmentApprovePreview from "@/views/workFlow/AppointmentApprovePreview";

  export default {
    name: "Approval",
    components: {
      AppointmentApprovePreview,
      ApprovalHeadForm,
      ReconcileOrderPreview,
    },
    data() {
      return {
        loadingHead: false,
        loadingSalesOrder: false,
        loadingBusinessApplication: false,
        loadingBusinessApplicationPriceApply: false,
        loadingOperationApplication: false,
        loadingProductionApplication: false,
        loadingDeliveryNoteApplication: false,
        loadingReplacementBillApplication: false,
        loadingPurchaseNgApplication: false,
        loadingProductNgApplication: false,
        loadingReconcileOrderControl: false,
        loadingStatusAppointmentControl: false,
        billId: null,
        billType: null,
        sequId: null,
        params: {},
      };
    },
    computed: {
      combinedLoading() {
        // 如果任何一个loading状态为true，则审批按钮loading为true
        return this.loadingHead || 
          this.loadingSalesOrder || 
          this.loadingBusinessApplication || 
          this.loadingOperationApplication || 
          this.loadingProductionApplication || 
          this.loadingDeliveryNoteApplication;
      },
    },
    created() {
      this.billType = this.$route.query.billType + "";
      this.billId = this.$route.query.billId + "";
      this.sequId = this.$route.query.sequId + "";
    },
    methods: {
      submit(row) {
        this.params = row;
      },
      loadingStatusHead(obj) {
        this.loadingHead = obj.loading;
      },
      loadingStatusSalesOrder(obj) {
        this.loadingSalesOrder = obj.loading;
      },
      loadingStatusBusinessApplication(obj) {
        this.loadingBusinessApplication = obj.loading;
      },
      loadingStatusBusinessApplicationPriceApply(obj) {
        this.loadingBusinessApplicationPriceApply = obj.loading;
      },
      loadingStatusOperationApplication(obj) {
        this.loadingOperationApplication = obj.loading;
      },
      loadingStatusProductionApplication(obj) {
        this.loadingProductionApplication = obj.loading;
      },
      loadingStatusDeliveryNoteApplication(obj) {
        this.loadingDeliveryNoteApplication = obj.loading;
      },
      loadingStatusReplacementBillApplication(obj) {
        this.loadingReplacementBillApplication = obj.loading;
      },
      loadingStatusPurchaseNgApplication(obj) {
        this.loadingPurchaseNgApplication = obj.loading;
      },
      loadingStatusProductNgApplication(obj) {
        this.loadingProductNgApplication = obj.loading;
      },
      loadingReconcileOrder(obj) {
        this.loadingReconcileOrderControl = obj.loading;
      },
      loadingStatusAppointmentApprove(obj) {
        this.loadingStatusAppointmentControl = obj.loading;
      },
    },
  };
</script>
<style lang="scss" scoped></style>
